import { useParams, Navigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { useGetWebsiteSettingsQuery, useGetPublishedPostQuery } from "../../../app/websiteApiSlice";
import ModernPost from "./themes/modern/ModernPost";
import ClassicPost from "./themes/classic/ClassicPost";
import BoldPost from "./themes/bold/BoldPost";

export default function WebsitePostRenderer() {
  const { slug } = useParams();
  const { data: settings, isLoading: loadingSettings } = useGetWebsiteSettingsQuery();
  const { data: post, isLoading: loadingPost, isError } = useGetPublishedPostQuery(slug);

  if (loadingSettings || loadingPost) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !post) return <Navigate to="/404" replace />;

  const theme = settings?.theme || "modern";

  switch (theme) {
    case "classic":
      return <ClassicPost post={post} settings={settings} />;
    case "bold":
      return <BoldPost post={post} settings={settings} />;
    case "modern":
    default:
      return <ModernPost post={post} settings={settings} />;
  }
}
